<pgh-modal-window size="sm">
    <h4 modal-title><adp-label [labelKey]="modalData.title"></adp-label></h4>
    <p modal-body class="mt-25 mb-25 text-center">
      <adp-label [labelKey]="modalData.content"></adp-label>
    </p>
    <div modal-footer>
      <button mat-flat-button color="accent" type="button" (click)="closeModal()"><adp-label [labelKey]="modalData.buttonText"></adp-label></button>
    </div>
</pgh-modal-window>
